import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/erinwang/Documents/GitHub/portfolio-v3/src/components/portfolio-page.js";
import { SingleImage } from '../../src/components/portfolio-page';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`project context`}</h2>
    <p>{`This was an assignment in my Information Design class at Northeastern University.`}</p>
    <p>{`Our task was to visualize three different trips I've taken starting from my apartment in Boston. Our destination were three different places in varying distances:`}</p>
    <ol>
      <li parentName="ol">{`To Northeastern University`}</li>
      <li parentName="ol">{`To any location outside of MA, for me this was back to my family home back in Connecticut`}</li>
      <li parentName="ol">{`To any location outside of the US – I chose my heritage country Taiwan.`}</li>
    </ol>
    <p>{`Not only did we have to document the ways we got there, but also 10 other pieces of information such as the time, activities, food, entertainment and emotions.`}</p>
    <SingleImage src='../../images/layers/layers.png' mdxType="SingleImage" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      